import React from "react";

interface ImgWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
}

const ImgWithFallback: React.FC<ImgWithFallbackProps> = ({
  src,
  fallbackSrc = "/images/noImg.png",
  ...rest
}) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = fallbackSrc;
  };

  return <img src={src || fallbackSrc} onError={handleError} {...rest} />;
};

export default ImgWithFallback;